import { types } from 'mobx-state-tree';
import DeltaTracker from './middleware/deltaTracker';

export const TrackableModel = types
  .model('TrackableModel', {
    tracker: types.optional(DeltaTracker, {})
  })
  .views(self => ({
    get hasChanges() {
      return self.tracker.hasChanges;
    }
  }));
